/* global Desmos */

import './ExamInterface.css';

import {
	FiBookmark,
	FiCheckSquare,
	FiChevronUp,
	FiEdit2,
	FiHelpCircle,
	FiMoreVertical,
} from 'react-icons/fi';
import React, { useEffect, useState } from 'react';
import {
	nextQuestion,
	prevQuestion,
	selectAnswer,
	setAnsweredQuestions,
	setIsBreakTime,
	setModule,
	setQuestion,
	setReviewMode,
	setSection,
	updateQuestionData,
} from '../../store/ExamSlice';
import { useDispatch, useSelector } from 'react-redux';

import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import { BsCalculator } from 'react-icons/bs';
import { BsFillKeyboardFill } from 'react-icons/bs';
import DirectionsModal from '../organisms/modal/DirectionsModal';
import ExitConfirmationModal from '../organisms/modal/ExitConfirmationModal';
import HelpModal from '../organisms/modal/HelpModal';
import { LOCAL_BASE_URL } from '../../constants/constants';
import Label from '../atoms/Label';
import QuestionOverviewModal from '../organisms/modal/QuestionOverviewModal';
import ShortcutsModal from '../organisms/modal/ShortcutsModal';
import axiosRequestInterceptor from '../../interceptor/axiosAPIRequestInterceptor';
import ic_down_direction from '../../assets/ic_down_direction.svg';
import locationIcon from '../../assets/ic_location.svg';
import { logger } from '../../utils/logger';
import reviewBadge from '../../assets/ic_review_badge.svg';
import { setAttempt } from '../../store/testSelectionSlice';
import unansweredIcon from '../../assets/ic_rectangle.svg';
import { useNavigate } from 'react-router-dom';
import { MathJax, MathJaxContext } from 'better-react-mathjax';

const mathJaxConfig = {
	loader: { load: ['input/tex', 'output/chtml'] },
  };


// const loadDesmos = () => {
//   return new Promise((resolve) => {
//     const script = document.createElement("script");
//     script.src =
//       "https://www.desmos.com/api/v1.10/calculator.js?apiKey=dcb31709b452b1cf9dc26972add0fda6";
//     script.onload = () => resolve();

//     document.head.appendChild(script);
//   });
// };

const QuizInterface = () => {
	const dispatch = useDispatch();
	const {
		currentQuestion,
		selectedAnswer,
		totalQuestions,
		answeredQuestions,
		currentSection,
		currentModule,
		isBreakTime,
		questionData,
		isReviewMode,
	} = useSelector((state) => state.ExamSlice);
	const { examId, selectedTest, reattemptId } = useSelector((state) => state.testSelection);
	const { userId, firstName, lastName } = useSelector((state) => state.userDetails);
	const options = ['A', 'B', 'C', 'D'];
	const sections = [
		{
			id: 'zoom',
			title: 'Zoom In/Out',
			content: (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<Label
						label="Use Keyboard Shortcuts to zoom in or out on laptops and pinch to zoom on tablets."
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
					<Label
						label={
							<>
								Windows and Chromebooks: <strong>Control + Plus (+)</strong> to zoom
								in and <strong>Control + Minus (-)</strong> to zoom out.
							</>
						}
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
					<Label
						label={
							<>
								Mac: <strong>Command + Plus (+)</strong> to zoom in and{' '}
								<strong>Command + Minus (-)</strong> to zoom out.
							</>
						}
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
				</div>
			),
		},
		{
			id: 'calculator',
			title: 'In-App Calculator',
			content: (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<Label
						label="On math questions you will have access to a graphing calculator built into the app. you can also use your own approved calculator."
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
				</div>
			),
		},
		{
			id: 'timer',
			title: 'Testing Timers',
			content: (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<Label
						label="During testing, a timer will let you know how much time remains for each module or part of the test."
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
					<Label
						label="At the end of the section 1, you'll have a short break. During the break we'll show you the timer counting down to the beginning of section 2."
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
				</div>
			),
		},
		{
			id: 'annotate',
			title: 'Annotation Tool',
			content: (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<Label
						label="On all exam questions, you can highlight a passes and write notes to yourself. Simply select some text, then select Annotate from the toolbar at the top right of the screen. Click Save to highlight the text or add a note and then click Save. You can hover over the annotation to read your note, or click into it to edit further. If you don't want to keep an annotation, just open it up and click Delete. You can annotate text from questions, passages, stimuli and source documents. You cannot annotate directions, pictures, buttons, or content from answer options. If the content you annotate is shared across multiple questions, your annotations will be available across all of those questions your annotations will not be graded."
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
				</div>
			),
		},
		{
			id: 'option-eliminator',
			title: 'Option Eliminator',
			content: (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<Label
						label="On any multiple-choice question you can use Option Eliminator mode to cross out any answer options you think are wrong. Above the answer, click the ABC button then you will see a button next to each answer option, allowing you to cross it out. You can always undo this action."
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
				</div>
			),
		},
		{
			id: 'mark-for-review',
			title: 'Mark for Review',
			content: (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<Label
						label="Usr the Mark for Review tool to flag any question you want to come back to later."
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
				</div>
			),
		},
		{
			id: 'question-menu',
			title: 'Question Menu',
			content: (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<Label
						label="At the bottom of each testing screen, you’ll find a menu that allows you to navigate to any question in this section. You will see which sections you’ve answered, which you haven’t, and any that you’ve marked for review"
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
				</div>
			),
		},
		{
			id: 'no-penalty-for-guessing',
			title: 'No Penalty for Guessing',
			content: (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<Label
						label="Points are never deducted for wrong answers. So, it’s always better to guess than to leave an answer blank."
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
				</div>
			),
		},
		{
			id: 'screen-readers',
			title: 'Screen Readers',
			content: (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<Label
						label="During testing, use the typical/native key commands that you normally use to navigate a webpage with your screen reader. Most exam pages are structured with the following reasons. You can navigate with these reasons/landmarks:"
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
					<ul style={{ marginLeft: '20px' }}>
						<li>
							Exam Player Controls
							<ul>
								<li>Test Timer</li>
								<li>Test Tools</li>
							</ul>
						</li>
						<li>
							Exam Stimulus/Passage
							<ul>
								<li>Footnotes</li>
								<li>Long Description</li>
							</ul>
						</li>
						<li>
							Exam Question
							<ul>
								<li>Question</li>
								<li>Answer Options</li>
								<li>Long Descriptions</li>
							</ul>
						</li>
						<li>Exam Navigation</li>
					</ul>
					<Label
						label="In general the following test components are structured with a heading:"
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
					<ul style={{ marginLeft: '20px' }}>
						<li>Test Name</li>
						<li>Passage Title/Source Documents, etc.</li>
					</ul>

					<Label
						label="Configuration"
						fontSize="13px"
						fontWeight="700"
						color="#000000"
						textAlign="left"
						style={{ marginTop: '16px' }}
					/>
					<Label
						label="Configure the settings for your assistive technology before you open the exam app preview and before check-in on exam day. These settings may include verbosity, punctuation, text processing, and other settings as needed. On exam day, once you start check-in you won't be able to adjust your settings as the digital testing application is locked down."
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
					<Label
						label="Configuration steps should be taken each time you take a digital practise or use the app demo, and on exam day before you cheque in for each exam."
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
				</div>
			),
		},
		{
			id: 'screen-magnification',
			title: 'Screen Magnification',
			content: (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					<Label
						label="Screen magnification technology enlarges the content displayed on the computer screen in order to assist students with visual impairments. Although the exam app supports some non-embedded screen magnifier tools from third parties; all users can zoom using their devices native controls (Control +/- on a Pc; Command +/- on a Mac; pinch and zoom on an iPad).
"
						fontSize="14px"
						fontWeight="400"
						color="#000000"
						textAlign="left"
					/>
				</div>
			),
		},
	];
	const api = axiosRequestInterceptor;
	const navigate = useNavigate();
	const [timeLeft, setTimeLeft] = useState(1920); // 31:25 in seconds
	const [isTimerHidden, setIsTimerHidden] = useState(false);
	const [isMoreOptionsOpen, setIsMoreOptionsOpen] = useState(false);
	const [strikedOptions, setStrikedOptions] = useState([]);
	const [isAbcMode, setIsAbcMode] = useState(false);
	const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
	const [isDirectionsModalOpen, setDirectionsModalOpen] = useState(true);
	const [isShortcutsModalOpen, setIsShortcutsModalOpen] = useState(false);
	const [isQuestionOverviewOpen, setIsQuestionOverviewOpen] = useState(false);
	const [markedQuestions, setMarkedQuestions] = useState([]);
	const [isExitModalOpen, setIsExitModalOpen] = useState(false);
	const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);
	const [calculator, setCalculator] = useState(null);
	const [calculatorWindow, setCalculatorWindow] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [isDirectionsOpen, setIsDirectionsOpen] = useState(false);
	const [questionTime, setQuestionTime] = useState(0);

	useEffect(() => {
		const blockReload = (e) => {
			if (
				e.key === 'F5' ||
				(e.ctrlKey && e.key === 'r') ||
				(e.ctrlKey && e.key === 'R') ||
				(e.metaKey && e.key === 'r')
			) {
				e.preventDefault();
				alert('Reload is disabled');
			}
		};

		const blockContextMenu = (event) => {
			event.preventDefault();
		};

		const preventBeforeUnload = (event) => {
			event.preventDefault();
			event.returnValue = ''; // Required for some browsers
		};

		// Attach event listeners
		window.addEventListener('keydown', blockReload);
		window.addEventListener('contextmenu', blockContextMenu);
		window.addEventListener('beforeunload', preventBeforeUnload);

		return () => {
			window.removeEventListener('keydown', blockReload);
			window.removeEventListener('contextmenu', blockContextMenu);
			window.removeEventListener('beforeunload', preventBeforeUnload);
		};
	}, []);

	useEffect(() => {
		setQuestionTime(Date.now());
	}, [currentQuestion]);

	useEffect(() => {
		if (isCalculatorOpen && !calculator) {
			const newWindow = window.open('', 'Calculator', 'width=600,height=400');
			setCalculatorWindow(newWindow);

			// Add necessary styles to the new window
			newWindow.document.head.innerHTML = `
        <style>
          body { margin: 0; padding: 20px; background: white; }
          #calculator { width: 100%; height: calc(100vh - 40px); }
        </style>
      `;
			newWindow.document.body.innerHTML = '<div id="calculator"></div>';

			// Load Desmos in the new window
			const script = newWindow.document.createElement('script');
			script.src =
				'https://www.desmos.com/api/v1.10/calculator.js?apiKey=dcb31709b452b1cf9dc26972add0fda6';
			script.onload = () => {
				const calc = newWindow.Desmos.GraphingCalculator(
					newWindow.document.getElementById('calculator')
				);
				setCalculator(calc);
			};
			newWindow.document.head.appendChild(script);

			// Handle window close
			newWindow.onbeforeunload = () => {
				setIsCalculatorOpen(false);
				setCalculator(null);
				setCalculatorWindow(null);
			};
		}

		return () => {
			if (calculatorWindow) {
				calculatorWindow.close();
			}
		};
	}, [isCalculatorOpen]);

	// Handle Module complete
	const handleModuleComplete = () => {
		setIsLoading(true);
		setTimeout(async () => {
			// Logic for module/section transitions
			if (selectedTest === 'SFT' || selectedTest === 'SATReattempt') {
				await handleConfirmExit();
				setIsLoading(false);
			} else {
				if (currentSection === 1) {
					if (currentModule === 1) {
						// setCurrentModule(2);
						dispatch(setModule(2));
						setTimeLeft(1920);
						setDirectionsModalOpen(true);
						dispatch(setReviewMode(false));
						setIsLoading(false);
					} else if (currentModule === 2) {
						dispatch(setIsBreakTime(true)); // Start break before Section 2
						setTimeLeft(600);
						// setCurrentSection(0);
						dispatch(setSection(0));
						// setCurrentModule(0);
						dispatch(setModule(0));
						dispatch(setReviewMode(false));
						setIsLoading(false);
					}
				} else if (isBreakTime) {
					dispatch(setIsBreakTime(false));
					// setCurrentSection(2);
					// setCurrentModule(1);
					dispatch(setSection(2));
					dispatch(setModule(1));
					dispatch(setReviewMode(false));
					setTimeLeft(2100);
					setDirectionsModalOpen(true);
					setIsLoading(false);
				} else if (currentSection === 2) {
					if (currentModule === 1) {
						// setCurrentModule(2);
						dispatch(setModule(2));
						setTimeLeft(2100);
						setDirectionsModalOpen(true);
						dispatch(setReviewMode(false));
						setIsLoading(false);
					}
					if (currentModule === 2) {
						await handleConfirmExit();
						setIsLoading(false);
					}
					// Handle end of exam after Section 2 Module 2
				}
			}

			// setCurrentQuestion(1);
			setMarkedQuestions([]);
			dispatch(setQuestion(1));
		}, 2000);
	};

	// Timer functionality
	useEffect(() => {
		const timer = setInterval(() => {
			setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
		}, 1000);

		return () => clearInterval(timer);
	}, []);

	useEffect(() => {
		if (timeLeft === 0) {
			handleModuleComplete(); // Trigger action when timer ends
		}
	}, [timeLeft]);

	const formatTime = (seconds) => {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
	};

	useEffect(() => {
		//change
		const fetchQuestionsByModule = async () => {
			if (selectedTest === 'SAT') {
				try {
					const questions = await api.post(`/exam/getQuestionsByModule`, {
						examId: `${examId}`,
						sectionId: `${currentSection}`,
						moduleId: `${currentModule}`,
					});
					logger.log('Exam questions:', questions?.data);
					// setQuestionData(questions?.data);
					dispatch(updateQuestionData(questions?.data));
					logger.log('number of questions = ', questions?.data?.length);
					// setTotalQuestions(questions?.data?.questions?.length);
					// dispatch(updateQuestionData(questions?.data?.questions?.length));
				} catch (error) {
					logger.log('Fetch question api Error:', error);
				}
			} else if (selectedTest === 'SATReattempt') {
				try {
					const questions = await api.post('/exam/getReattemptQuestions', {
						userId,
						reattemptId,
						examId,
					});
					logger.log('Exam questions:', questions?.data);
					// setQuestionData(questions?.data);
					dispatch(updateQuestionData(questions?.data));
					logger.log('number of questions = ', questions?.data?.length);
				} catch (error) {
					logger.log('Fetch question api Error:', error);
				}
			}
		};
		if (selectedTest !== 'SFT') fetchQuestionsByModule();
	}, [currentSection, currentModule]);

	useEffect(() => {
		if (
			answeredQuestions[currentSection] &&
			answeredQuestions[currentSection][currentModule] &&
			answeredQuestions[currentSection][currentModule][currentQuestion]
		) {
			// setSelectedAnswer(answeredQuestions[currentQuestion]);
			dispatch(
				selectAnswer(
					answeredQuestions[currentSection][currentModule][currentQuestion]['ans']
				)
			);
		}
	}, [currentQuestion]);

	const handleGoToReview = () => {
		// setIsReviewMode(true);
		dispatch(setReviewMode(true));
		setIsQuestionOverviewOpen(false);
	};

	const handleNext = () => {
		//change
		if (selectedAnswer) {
			if (selectedTest === 'SFT') {
				api.post(`/sft/saveQuestionResponse`, {
					userId: userId,
					testId: examId,
					questionResponse: {
						questionId: questionData?.questions?.[currentQuestion - 1]?.QUESTION_ID,
						questionType:
							questionData?.questions?.[currentQuestion - 1]?.ANSWER?.ANSWER_TYPE,
						textAnswer: selectedAnswer,
						timeTaken:
							answeredQuestions?.[currentSection]?.[currentModule]?.[currentQuestion]
								?.timeTaken, // in seconds (optional)
					},
				});
			} else if (selectedTest === 'SAT') {
				api.post(`/exam/submitAnswer`, {
					examId: examId,
					sectionId: `${currentSection}`,
					moduleId: `${currentModule}`,
					questionId: `${currentQuestion}`,
					userId: userId,
					answer: selectedAnswer,
					question: questionData?.questions?.[currentQuestion - 1]?.QUESTION?.TEXT || '',
					answer_type:
						questionData?.questions?.[currentQuestion - 1]?.ANSWER?.ANSWER_TYPE,
					options:
						questionData?.questions?.[currentQuestion - 1]?.OPTIONS?.map(
							(option) => option?.ID
						) || [],
					timeTaken:
						answeredQuestions?.[currentSection]?.[currentModule]?.[currentQuestion]
							?.timeTaken,
				});
			} else if (selectedTest === 'SATReattempt') {
				api.post('/exam/saveReattemptResponse', {
					reattemptId,
					examId,
					questionId:
						questionData?.questions?.[currentQuestion - 1]?.SECTION_MODULE_QUESTION,
					response: selectedAnswer,
					answerType: questionData?.questions?.[currentQuestion - 1]?.ANSWER?.ANSWER_TYPE,
					timeTaken:
						answeredQuestions?.[currentSection]?.[currentModule]?.[currentQuestion]
							?.timeTaken,
				});
			}
		}
		if (isReviewMode) {
			// currentModule < 2
			//   ? setCurrentModule((prev) => prev + 1)
			//   : currentSection === 1
			//   ? setIsBreakTime(true)
			//   : setIsLoading(true);
			handleModuleComplete();
			// setIsReviewMode(false);
			dispatch(setReviewMode(false));
		}
		// else if (currentQuestion < totalQuestions) {
		//   setCurrentQuestion((prev) => prev + 1);
		//   setSelectedAnswer(null);
		// } else {
		//   // setCurrentModule((prev) => prev + 1)
		//   // setIsReviewMode(true);
		//   dispatch(setReviewMode(true));
		// }
		setStrikedOptions([]);
		dispatch(nextQuestion());
	};

	const handleBack = () => {
		dispatch(prevQuestion());
	};

	const handleStrikeOption = (optionId) => {
		setStrikedOptions((prev) =>
			prev.includes(optionId) ? prev?.filter((id) => id !== optionId) : [...prev, optionId]
		);
		if (optionId === selectedAnswer) {
			dispatch(selectAnswer(null));
		}
	};

	const handleAbcClick = () => {
		if (isAbcMode) setStrikedOptions([]);
		setIsAbcMode((prev) => !prev);
	};

	const handleMarkForReview = () => {
		setMarkedQuestions((prev) =>
			prev.includes(currentQuestion)
				? prev?.filter((q) => q !== currentQuestion)
				: [...prev, currentQuestion]
		);
	};

	const handleQuestionSelect = (questionNumber) => {
		// setCurrentQuestion(questionNumber);
		dispatch(setQuestion(questionNumber));
		setIsQuestionOverviewOpen(false);
	};

	const handleAnswerSelect = (optionId) => {
		// setSelectedAnswer(optionId);
		dispatch(selectAnswer(optionId));
		// if (!answeredQuestions?.currentQuestion) {
		//   setAnsweredQuestions((prev) => ({
		//     ...prev,
		//     [currentQuestion]: optionId,
		//   }));
		const timeTaken = ((Date.now() - questionTime) / 1000).toFixed(2);
		dispatch(
			setAnsweredQuestions({
				section: currentSection,
				module: currentModule,
				question: currentQuestion,
				answer: {
					ans: optionId,
					timeTaken: timeTaken,
				},
			})
		);
	};

	const isCurrentQuestionMarked = markedQuestions.includes(currentQuestion);

	const handleEndAndScore = () => {
		setIsExitModalOpen(true);
		setIsMoreOptionsOpen(false);
	};

	const handleConfirmExit = () => {
		if (selectedTest === 'SFT') {
			api.post(`/sft/finalizeTestSubmission`, {
				userId: userId || '',
				testId: examId || '',
			})
				.then((response) => {
					logger.log('Exiting test...');
					navigate('/exam-score', { state: { fromExam: true } });
					// navigate("/exam-score");
				})
				.catch((error) => {
					logger.log('Error finalizing exam:', error);
					alert('There was an error submitting your exam. Please try again.');
				});
		} else if (selectedTest === 'SAT') {
			api.post(`/exam/finalizeExamAttempt`, {
				userId: userId || '',
				examId: examId || '',
			})
				.then((response) => {
					logger.log('Exiting test...', response);
					dispatch(setAttempt(response.data.attemptNumber));
					navigate('/exam-score', { state: { fromExam: true } });
					// navigate("/exam-score");
				})
				.catch((error) => {
					logger.log('Error finalizing exam:', error);
					alert('There was an error submitting your exam. Please try again.');
				});
		} else if (selectedTest === 'SATReattempt') {
			navigate('/exam-score', { state: { fromExam: true } });
		}
		// Add your exit logic here
		// logger.log("Exiting test...");
		// navigate("/exam-score");
	};

	// Loading screen component
	const LoadingScreen = () => (
		<div className="module-complete-screen">
			<h2 className="module-complete-title">This Module is Over</h2>
			<p>All your work has been saved.</p>
			<p>You'll move on automatically in just a moment.</p>
			<div className="loading-spinner" />
		</div>
	);

	// Break screen component
	const BreakScreen = () => (
		<div className="break-screen">
			<div className="break-header">
				<h1>DSAT Exam</h1>
			</div>

			<div className="break-content">
				<div
					style={{
						minWidth: '45%',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						minHeight: '100%',
					}}
				>
					<div className="break-timer-container">
						<p>Remaining Break Time:</p>
						<div className="break-timer">{formatTime(timeLeft)}</div>
						<button className="resume-testing-btn" onClick={handleModuleComplete}>
							Resume Testing
						</button>
					</div>
				</div>
				<div
					style={{
						borderLeft: 'solid 2px #fff',
						paddingLeft: '2rem',
						maxWidth: '50%',
					}}
				>
					<div className="break-instructions" style={{ textAlign: 'start' }}>
						<h2>Practice Test Break</h2>
						<h3>
							You can resume this practice test as soon as you're ready to move on. On
							the test day, you'll wait until the clock counts down. Read below to see
							how breaks work on test day.
						</h3>

						<h2>Take a Break</h2>
						<h3>
							You may leave the room but do not disturb students who are still
							testing.
							<br />
							Testing won't resume until you return.
						</h3>

						<h2>Follow these rules during the break:</h2>
						<ol>
							<li>
								<h3>
									Do not access your phone smartwatch, testbook, notes or the
									internet.
								</h3>
							</li>
							<li>
								<h3>Do not eat or drink in the test room.</h3>
							</li>
							<li>
								<h3>
									Do not speak in the test room; outside the test room, do not
									discuss the exam with anyone.
								</h3>
							</li>
						</ol>
					</div>
				</div>
			</div>
			<div
				style={{
					textAlign: 'start',
					marginTop: '2.5rem',
					borderTop: 'solid 2px #fff',
					height: 'fit-content',
				}}
			>
				<p style={{ color: 'white', margin: '0' }}>
					{firstName} {lastName}
				</p>
			</div>
		</div>
	);

	// Render appropriate screen based on state
	if (isLoading) {
		return <LoadingScreen />;
	}

	if (isBreakTime) {
		return <BreakScreen />;
	}

	return (
		<div
			style={{
				width: '100%',
				height: 'auto',
				background: '#5D5D5D',
				// padding: "20px",
				boxSizing: 'border-box',
				// overflow: "hidden",
			}}
		>
			<div className={`exam-interface-container ${isAbcMode ? 'abc-mode' : ''}`}>
				<div className="exam-interface-header">
					<div className="exam-interface-section-info">
						<Label
							label={`Section ${currentSection}: ${
								currentSection === 1 ? 'Reading and Writing' : 'Math'
							}`}
							fontSize={'20px'}
							color={'#000000'}
							fontWeight={'400'}
						/>
						<Label
							label={`Module ${currentModule}`}
							fontSize={'16px'}
							color={'#000000'}
							fontWeight={'400'}
						/>
						<div className="exam-interface-directions">
							<Label
								label={'Directions'}
								fontSize={'16px'}
								color={'#000000'}
								fontWeight={'400'}
							/>
							<img
								src={ic_down_direction}
								alt="arrow-right"
								onClick={() => setIsDirectionsOpen(!isDirectionsOpen)}
							/>
						</div>
					</div>

					<div className={`timer-controls`}>
						{isTimerHidden ? (
							<div className="timer">
								<AccessAlarmsIcon />
							</div>
						) : (
							<div className="timer">{formatTime(timeLeft)}</div>
						)}
						<button
							className="exam-interface-hide-btn"
							onClick={() => setIsTimerHidden(!isTimerHidden)}
						>
							{isTimerHidden ? 'Show' : 'Hide'}
						</button>
					</div>

					<div className="exam-interface-action-buttons">
						{currentSection === 2 && (
							<button
								className="exam-interface-icon-btn annotate-btn"
								onClick={() => setIsCalculatorOpen(!isCalculatorOpen)}
							>
								{<BsCalculator />}
								<Label
									label={'Calculator'}
									fontSize={'16px'}
									color={'#000000'}
									fontWeight={'400'}
								/>
							</button>
						)}
						<div className="more-options-container">
							<button
								className="exam-interface-icon-btn more-btn"
								onClick={() => setIsMoreOptionsOpen(!isMoreOptionsOpen)}
							>
								<FiMoreVertical />
								<Label
									label={'More'}
									fontSize={'16px'}
									color={'#000000'}
									fontWeight={'400'}
								/>
							</button>
							{isMoreOptionsOpen && (
								<div className="more-options-dropdown">
									<button
										className="more-option-item"
										onClick={() => {
											setIsHelpModalOpen(true);
											setIsMoreOptionsOpen(false);
										}}
									>
										<FiHelpCircle />
										<Label
											label={'Help'}
											fontSize={'14px'}
											color={'#000000'}
											fontWeight={'400'}
										/>
									</button>
									<button
										className="more-option-item"
										onClick={() => {
											setIsShortcutsModalOpen(true);
											setIsMoreOptionsOpen(false);
										}}
									>
										<BsFillKeyboardFill />
										<Label
											label={'Shortcuts'}
											fontSize={'14px'}
											color={'#000000'}
											fontWeight={'400'}
										/>
									</button>
									<button
										className="more-option-item"
										onClick={handleEndAndScore}
									>
										<FiCheckSquare />
										<Label
											label={'End and Score'}
											fontSize={'14px'}
											color={'#000000'}
											fontWeight={'400'}
										/>
									</button>
								</div>
							)}
						</div>
					</div>
				</div>

				{isReviewMode ? (
					<div
						style={{
							alignItems: 'center',
							justifyContent: 'center',
							display: 'flex',
							flexDirection: 'column',
							paddingBottom: '4rem',
						}}
					>
						<Label
							label={'Check Your Work'}
							fontSize={'31px'}
							color={'#000000'}
							fontWeight={'400'}
							style={{ marginTop: '20px' }}
						/>
						<Label
							label={
								'On the test day, you won’t be able to move on to the next module until time expires. For these practice test, you can click Next when you are ready to move on.'
							}
							fontSize={'16px'}
							color={'#000000'}
							fontWeight={'400'}
							style={{
								marginBottom: '20px',
								width: '710px',
								marginTop: '20px',
							}}
						/>
						<div
							className="question-overview-modal"
							style={{
								boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
								backgroundColor: 'white',
								borderRadius: '8px',
							}}
						>
							<div className="question-overview-modal-header">
								<h4>Section 1, Module 1: Reading and Writing</h4>
								<div className="legend-overview ">
									<div className="legend-overview-item">
										<img
											src={unansweredIcon}
											alt="Review Badge"
											className="review-badge"
										/>{' '}
										Unanswered
									</div>
									<div className="legend-overview-item">
										<img
											src={reviewBadge}
											alt="Review Badge"
											className="review-badge"
										/>{' '}
										For Review
									</div>
								</div>
							</div>

							<div className="questions-grid">
								{[...Array(totalQuestions)]?.map((_, index) => {
									const questionNum = index + 1;
									const isMarked = markedQuestions.includes(questionNum);
									const isAnswered =
										answeredQuestions?.[currentSection]?.[currentModule]?.[
											questionNum
										];
									const isCurrent = currentQuestion === questionNum;

									return (
										<button
											key={questionNum}
											className={`question-button ${
												isAnswered ? 'answered' : ''
											} ${isCurrent ? 'current' : ''}`}
											onClick={() => {
												handleQuestionSelect(questionNum);
												// setIsReviewMode(false);
												dispatch(setReviewMode(false));
											}}
										>
											{questionNum}
											{isMarked && (
												<img
													src={reviewBadge}
													alt="Review Badge"
													className="review-indicator"
												/>
											)}
											{isCurrent && (
												<img
													src={locationIcon}
													alt="Current"
													className="current-indicator"
												/>
											)}
										</button>
									);
								})}
							</div>
						</div>
					</div>
				) : questionData?.questions?.[currentQuestion - 1]?.VIEW_TYPE === 'vertical' ? (
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
						className="exam-interface-content"
					>
						<div className="exam-interface-single-coloum">
							<div className="exam-interface-question-header">
								<div className="exam-left-section">
									<span className="exam-interface-question-number">
										{currentQuestion}
									</span>
									<button
										className={`exam-interface-mark-review ${
											isCurrentQuestionMarked ? 'marked' : ''
										}`}
										onClick={handleMarkForReview}
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: '5px',
											background: 'transparent',
											border: 'none',
											cursor: 'pointer',
										}}
									>
										<FiBookmark
											style={{
												color: !isCurrentQuestionMarked
													? 'currentColor'
													: '#FEDB00',
												fill: !isCurrentQuestionMarked ? 'none' : '#FFD700',
											}}
										/>
										<span>Mark for Review</span>
									</button>
								</div>
								{questionData?.questions?.[currentQuestion - 1]?.ANSWER
									?.ANSWER_TYPE === 'multiple-choice' && (
									<button
										className={`abc-button ${isAbcMode ? 'active' : ''}`}
										onClick={handleAbcClick}
										style={{
											backgroundColor: isAbcMode ? '#1F21E6' : '#fff',
											color: isAbcMode ? '#fff' : '#000',
											borderRadius: '4px',
											padding: '5px 5px',
											fontSize: '12px',
											fontWeight: '400',
											border: isAbcMode
												? '1px solid #1F21E6'
												: '1px solid #000',
											boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
											cursor: 'pointer',
											minWidth: '30px',
											position: 'relative',
											overflow: 'visible',
										}}
									>
										ABC
									</button>
								)}
							</div>
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								{questionData?.questions?.[currentQuestion - 1]?.QUESTION?.IMAGE
									?.url &&
									questionData?.questions?.[currentQuestion - 1]?.QUESTION?.IMAGE
										?.position === 'TOP' && (
										<div>
											<img
												src={
													questionData?.questions?.[currentQuestion - 1]
														?.QUESTION?.IMAGE?.url
												}
												alt="question"
											/>
										</div>
									)}
								<MathJaxContext config={mathJaxConfig}>
									<MathJax hideUntilTypeset="first"> 
									<div
										className="exam-interface-single-coloum-question-p1"
										dangerouslySetInnerHTML={{
											__html: questionData?.questions?.[currentQuestion - 1]
												?.QUESTION?.TEXT?.html,
										}}
									></div>
									</MathJax>
								</MathJaxContext>
								{questionData?.questions?.[currentQuestion - 1]?.QUESTION?.IMAGE
									?.url &&
									questionData?.questions?.[currentQuestion - 1]?.QUESTION?.IMAGE
										?.position === 'BOTTOM' && (
										<div>
											<img
												src={
													questionData?.questions?.[currentQuestion - 1]
														?.QUESTION?.IMAGE?.url
												}
												alt="question"
											/>
										</div>
									)}
							</div>
							<div className="answer-section">
								{questionData?.questions?.[
									currentQuestion - 1
								]?.QUESTION?.ADDITIONAL_TEXT.trim() && (
									<div style={{ marginTop: '20px', marginBottom: '50px' }}>
										{/* <Label
                  label={
                    // "Which Choice completes the text with the most logical and precise word or phrase?"
                    questionData?.questions?.[currentQuestion - 1]?.QUESTION
                      ?.ADDITIONAL_TEXT
                  }
                  fontSize={"16px"}
                  color={"#000000"}
                  fontWeight={"400"}
                /> */}
									<MathJaxContext config={mathJaxConfig}>
										<MathJax hideUntilTypeset="first">
										<label
											style={{
												fontFamily: 'Helvetica',
												fontSize: '1rem',
												color: '#000000',
												fontWeight: '400',
												textAlign: 'start',
											}}
											dangerouslySetInnerHTML={{
												__html: questionData?.questions?.[
													currentQuestion - 1
												]?.QUESTION?.ADDITIONAL_TEXT,
											}}
										></label>
										</MathJax>
									</MathJaxContext>
									</div>
								)}
								<div className="options">
									{questionData?.questions?.[currentQuestion - 1]?.ANSWER
										?.ANSWER_TYPE === 'multiple-choice' ? (
										questionData?.questions?.[currentQuestion - 1]?.OPTIONS &&
										// JSON.parse(
										questionData?.questions?.[currentQuestion - 1]?.OPTIONS
											// )
											?.map((option, id) => (
												<div
													key={id}
													className="option-container"
													style={{
														display: 'flex',
														alignItems: 'center',
														marginBottom: '10px',
														gap: '10px',
														width: '100%',
													}}
												>
													<button
														className={`option-btn ${
															selectedAnswer === options[id] ||
															answeredQuestions?.[currentSection]?.[
																currentModule
															]?.[currentQuestion] === options[id]
																? 'selected'
																: ''
														}`}
														onClick={() =>
															handleAnswerSelect(options[id])
														}
														style={{
															textDecoration: strikedOptions.includes(
																options[id]
															)
																? 'line-through'
																: 'none',
															flex: 1,
															display: 'flex',
															alignItems: 'center',
															background:
																selectedAnswer === options[id]
																	? '#e6f3ff'
																	: '#fff',
															border:
																selectedAnswer === options[id]
																	? '1px solid #1a73e8'
																	: '1px solid #ccc',
															borderRadius: '8px',
															// padding: "10px",
															cursor: 'pointer',
														}}
														disabled={strikedOptions.includes(
															options[id]
														)}
													>
														<span
															className={`option-id ${
																selectedAnswer === options[id]
																	? 'option-id-selected'
																	: ''
															}`}
														>
															{options[id]}
														</span>
														<MathJaxContext config={mathJaxConfig}>
															<MathJax hideUntilTypeset="first">
														<span
															className="option-text"
															dangerouslySetInnerHTML={{
																__html: option?.TEXT,
															}}
															></span>
															</MathJax>
														</MathJaxContext>
													</button>
													<button
														className={
															strikedOptions.includes(options[id])
																? 'undo-button'
																: 'strike-button'
														}
														onClick={(e) => {
															e.stopPropagation();
															handleStrikeOption(options[id]);
														}}
													>
														{strikedOptions.includes(options[id])
															? 'Undo'
															: options[id]}
													</button>
												</div>
											))
									) : (
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'start',
											}}
										>
											<div class="input-container">
												<div class="input-box">
													<input
														type="text"
														value={selectedAnswer || ''}
														onChange={(e) => {
															e.target.value = e.target.value.replace(
																/[^0-9./]/g,
																''
															);

															// setSelectedAnswer(e.target.value);
															dispatch(selectAnswer(e.target.value));
															// setAnsweredQuestions((prev) => ({
															//   ...prev,
															//   [currentQuestion]: e.target.value,
															// }));
															const timeTaken = (
																(Date.now() - questionTime) /
																1000
															).toFixed(2);
															dispatch(
																setAnsweredQuestions({
																	section: currentSection,
																	module: currentModule,
																	question: currentQuestion,
																	answer: {
																		ans: e.target.value,
																		timeTaken: timeTaken,
																	},
																})
															);
														}}
														maxLength={5}
													/>
												</div>
											</div>
											<p>
												<span class="answer-preview">Answer Preview: </span>
												{selectedAnswer?.includes('/') &&
												selectedAnswer?.length > 1 ? (
													<span
														style={{
															display: 'inline-flex',
															flexDirection: 'column',
															alignItems: 'center',
															marginLeft: '10px',
														}}
													>
														<span>
															{selectedAnswer.split('/')[0].trim()}
														</span>
														<span
															style={{
																borderTop: '2px solid black',
																width: '100%',
															}}
														></span>
														<span>
															{selectedAnswer.split('/')[1].trim()}
														</span>
													</span>
												) : (
													selectedAnswer
												)}
											</p>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="exam-interface-content">
						<div
							style={{ display: 'flex', flexDirection: 'column' }}
							className="exam-interface-question-content"
						>
							{questionData?.questions?.[currentQuestion - 1]?.QUESTION?.IMAGE?.url &&
								questionData?.questions?.[currentQuestion - 1]?.QUESTION?.IMAGE
									?.position === 'TOP' && (
									<div>
										<img
											style={{ maxWidth: '100%' }}
											src={
												questionData?.questions?.[currentQuestion - 1]
													?.QUESTION?.IMAGE?.url
											}
											alt="question"
										/>
									</div>
								)}
							<MathJaxContext config={mathJaxConfig}>
								<MathJax hideUntilTypeset="first">
							<div
								dangerouslySetInnerHTML={{
									__html: questionData?.questions?.[currentQuestion - 1]?.QUESTION
										?.TEXT?.html,
								}}
							></div>
							</MathJax>
							</MathJaxContext>
							{questionData?.questions?.[currentQuestion - 1]?.QUESTION?.IMAGE?.url &&
								questionData?.questions?.[currentQuestion - 1]?.QUESTION?.IMAGE
									?.position === 'BOTTOM' && (
									<div>
										<img
											style={{ width: '100%' }}
											src={
												questionData?.questions?.[currentQuestion - 1]
													?.QUESTION?.IMAGE?.url
											}
											alt="question"
										/>
									</div>
								)}
						</div>

						<div className="answer-section">
							<div className="exam-interface-question-header">
								<div className="exam-left-section">
									<span className="exam-interface-question-number">
										{currentQuestion}
									</span>
									<button
										className={`exam-interface-mark-review ${
											isCurrentQuestionMarked ? 'marked' : ''
										}`}
										onClick={handleMarkForReview}
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: '5px',
											background: 'transparent',
											border: 'none',
											cursor: 'pointer',
										}}
									>
										<FiBookmark
											style={{
												color: !isCurrentQuestionMarked
													? 'currentColor'
													: '#FEDB00',
												fill: !isCurrentQuestionMarked ? 'none' : '#FFD700',
											}}
										/>
										<span>Mark for Review</span>
									</button>
								</div>
								{questionData?.questions?.[currentQuestion - 1]?.ANSWER
									?.ANSWER_TYPE === 'multiple-choice' && (
									<button
										className={`abc-button ${isAbcMode ? 'active' : ''}`}
										onClick={handleAbcClick}
										style={{
											backgroundColor: isAbcMode ? '#1F21E6' : '#fff',
											color: isAbcMode ? '#fff' : '#000',
											borderRadius: '4px',
											padding: '5px 5px',
											fontSize: '12px',
											fontWeight: '400',
											border: isAbcMode
												? '1px solid #1F21E6'
												: '1px solid #000',
											boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
											cursor: 'pointer',
											minWidth: '30px',
											position: 'relative',
											overflow: 'visible',
										}}
									>
										ABC
									</button>
								)}
							</div>

							{questionData?.questions?.[
								currentQuestion - 1
							]?.QUESTION?.ADDITIONAL_TEXT.trim() && (
								<div style={{ marginTop: '20px', marginBottom: '50px' }}>
									{/* <Label
                  label={
                    // "Which Choice completes the text with the most logical and precise word or phrase?"
                    questionData?.questions?.[currentQuestion - 1]?.QUESTION
                      ?.ADDITIONAL_TEXT
                  }
                  fontSize={"16px"}
                  color={"#000000"}
                  fontWeight={"400"}
                /> */}
									<MathJaxContext config={mathJaxConfig}>
										<MathJax hideUntilTypeset="first">		
									<label
										style={{
											fontFamily: 'Helvetica',
											fontSize: '1rem',
											color: '#000000',
											fontWeight: '400',
											textAlign: 'start',
										}}
										dangerouslySetInnerHTML={{
											__html: questionData?.questions?.[currentQuestion - 1]
												?.QUESTION?.ADDITIONAL_TEXT,
										}}
									></label>
									</MathJax>
									</MathJaxContext>
								</div>
							)}
							<div className="options">
								{questionData?.questions?.[currentQuestion - 1]?.ANSWER
									?.ANSWER_TYPE === 'multiple-choice' ? (
									questionData?.questions?.[currentQuestion - 1]?.OPTIONS &&
									// JSON.parse(
									questionData?.questions?.[currentQuestion - 1]?.OPTIONS
										// )
										?.map((option, id) => (
											<div
												key={id}
												className="option-container"
												style={{
													display: 'flex',
													alignItems: 'center',
													marginBottom: '10px',
													gap: '10px',
													width: '100%',
												}}
											>
												<button
													className={`option-btn ${
														selectedAnswer === options[id] ||
														answeredQuestions[currentQuestion] ===
															options[id]
															? 'selected'
															: ''
													}`}
													onClick={() => handleAnswerSelect(options[id])}
													style={{
														textDecoration: strikedOptions.includes(
															options[id]
														)
															? 'line-through'
															: 'none',
														flex: 1,
														display: 'flex',
														alignItems: 'center',
														background:
															selectedAnswer === options[id]
																? '#e6f3ff'
																: '#fff',
														border:
															selectedAnswer === options[id]
																? '1px solid #1a73e8'
																: '1px solid #ccc',
														borderRadius: '8px',
														// padding: "10px",
														cursor: 'pointer',
													}}
													disabled={strikedOptions.includes(options[id])}
												>
													<span
														className={`option-id ${
															selectedAnswer === options[id]
																? 'option-id-selected'
																: ''
														}`}
													>
														{options[id]}
													</span>
													<MathJaxContext config={mathJaxConfig}>
														<MathJax hideUntilTypeset="first">
													<span
														className="option-text"
														dangerouslySetInnerHTML={{
															__html: option?.TEXT,
														}}
													></span>
													</MathJax>
													</MathJaxContext>
												</button>
												<button
													className={
														strikedOptions.includes(options[id])
															? 'undo-button'
															: 'strike-button'
													}
													onClick={(e) => {
														e.stopPropagation();
														handleStrikeOption(options[id]);
													}}
												>
													{strikedOptions.includes(options[id])
														? 'Undo'
														: options[id]}
												</button>
											</div>
										))
								) : (
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'start',
										}}
									>
										<div class="input-container">
											<div class="input-box">
												<input
													type="text"
													value={selectedAnswer || ''}
													onChange={(e) => {
														e.target.value = e.target.value.replace(
															/[^0-9./]/g,
															''
														);
														// setSelectedAnswer(e.target.value);
														dispatch(selectAnswer(e.target.value));
														// setAnsweredQuestions((prev) => ({
														//   ...prev,
														//   [currentQuestion]: e.target.value,
														// }));
														const timeTaken = (
															(Date.now() - questionTime) /
															1000
														).toFixed(2);
														dispatch(
															setAnsweredQuestions({
																section: currentSection,
																module: currentModule,
																question: currentQuestion,
																answer: {
																	ans: e.target.value,
																	timeTaken: timeTaken,
																},
															})
														);
													}}
													maxLength={5}
												/>
											</div>
										</div>
										<p class="answer-preview">
											Answer Preview: {selectedAnswer}
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				)}

				<div className="exam-interface-footer">
					{!isReviewMode && (
						<div
							className="question-counter"
							onClick={() => setIsQuestionOverviewOpen(true)}
							style={{
								cursor: 'pointer',
								display: 'flex',
								alignItems: 'center',
								gap: '5px',
							}}
						>
							Question {currentQuestion} of {totalQuestions}
							<FiChevronUp />
						</div>
					)}
					<div className="navigation-buttons">
						<button
							className="nav-btn back"
							onClick={() => {
								if (isReviewMode) {
									// setIsReviewMode(false);
									dispatch(setReviewMode(false));
									// setCurrentQuestion(totalQuestions);
								} else {
									handleBack();
								}
							}}
							disabled={currentQuestion === 1 && !isReviewMode}
						>
							Back
						</button>
						<button
							className="nav-btn next"
							onClick={handleNext}
							// disabled={currentQuestion === totalQuestions}
						>
							Next
						</button>
					</div>
				</div>

				{/* Add the Directions Modal */}
				{isDirectionsOpen && (
					<div className="directions-modal-overlay">
						<div className="directions-modal">
							<div className="directions-modal-content">
								<p>
									The question in the section address are number of important
									reading and writing skills. Each question include one or more
									passages, which may include a table or a graph. Read each
									passage and question carefully, and then choose the best answer
									to the question based on the passage(s)
								</p>
								<p>
									All questions in these section are multiple-choice with four
									answer choices. Each question has a single best answer.
								</p>
								<p>
									The question in the section address are number of important
									reading and writing skills. Each question include one or more
									passages, which may include a table or a graph. Read each
									passage and question carefully, and then choose the best answer
									to the question based on the passage(s)
								</p>
								<p>
									All questions in these section are multiple-choice with four
									answer choices. Each question has a single best answer.
								</p>
								<p>
									The question in the section address are number of important
									reading and writing skills. Each question include one or more
									passages, which may include a table or a graph. Read each
									passage and question carefully, and then choose the best answer
									to the question based on the passage(s)
								</p>
								<p>
									All questions in these section are multiple-choice with four
									answer choices. Each question has a single best answer.
								</p>
								<p>
									The question in the section address are number of important
									reading and writing skills. Each question include one or more
									passages, which may include a table or a graph. Read each
									passage and question carefully, and then choose the best answer
									to the question based on the passage(s)
								</p>
								<p>
									All questions in these section are multiple-choice with four
									answer choices. Each question has a single best answer.
								</p>
								<p>
									The question in the section address are number of important
									reading and writing skills. Each question include one or more
									passages, which may include a table or a graph. Read each
									passage and question carefully, and then choose the best answer
									to the question based on the passage(s)
								</p>
								<p>
									All questions in these section are multiple-choice with four
									answer choices. Each question has a single best answer.
								</p>
								<p>
									The question in the section address are number of important
									reading and writing skills. Each question include one or more
									passages, which may include a table or a graph. Read each
									passage and question carefully, and then choose the best answer
									to the question based on the passage(s)
								</p>
								<p>
									All questions in these section are multiple-choice with four
									answer choices. Each question has a single best answer.
								</p>
								<p>
									The question in the section address are number of important
									reading and writing skills. Each question include one or more
									passages, which may include a table or a graph. Read each
									passage and question carefully, and then choose the best answer
									to the question based on the passage(s)
								</p>
								<p>
									All questions in these section are multiple-choice with four
									answer choices. Each question has a single best answer.
								</p>
								<p>
									The question in the section address are number of important
									reading and writing skills. Each question include one or more
									passages, which may include a table or a graph. Read each
									passage and question carefully, and then choose the best answer
									to the question based on the passage(s)
								</p>
								<p>
									All questions in these section are multiple-choice with four
									answer choices. Each question has a single best answer.
								</p>
							</div>
							<button
								className="close-modal-btn"
								onClick={() => setIsDirectionsOpen(false)}
							>
								Close
							</button>
						</div>
					</div>
				)}

				<DirectionsModal
					isOpen={isDirectionsModalOpen}
					onClose={() => setDirectionsModalOpen(false)}
					section={currentSection}
				/>

				<HelpModal
					isOpen={isHelpModalOpen}
					onClose={() => setIsHelpModalOpen(false)}
					sections={sections}
				/>

				<ShortcutsModal
					isOpen={isShortcutsModalOpen}
					onClose={() => setIsShortcutsModalOpen(false)}
				/>

				<QuestionOverviewModal
					isOpen={isQuestionOverviewOpen}
					onClose={() => setIsQuestionOverviewOpen(false)}
					currentQuestion={currentQuestion}
					totalQuestions={totalQuestions}
					markedQuestions={markedQuestions}
					answeredQuestions={answeredQuestions}
					onQuestionClick={handleQuestionSelect}
					onReviewPage={handleGoToReview}
					currentModule={currentModule}
					currentSection={currentSection}
				/>

				<ExitConfirmationModal
					isOpen={isExitModalOpen}
					onClose={() => setIsExitModalOpen(false)}
					onConfirm={handleConfirmExit}
				/>
			</div>
		</div>
	);
};

export default QuizInterface;
